import { formatHelper } from "../../common/helpers";
import { toMoney } from "../../common/helpers/format";

export const selectDailyBalanceColumns = (state) => {
  const dailyBalanceValue = state.report.dailyBalanceList.dailyBalance;

  var data = [];

  if (!dailyBalanceValue || dailyBalanceValue.length == 0) return data;

  const max = dailyBalanceValue.length;

  for (let i = 0; i < max; i++) {
    const dailyBalance = dailyBalanceValue[i];

    let object = {
      id: 0,
      created_at_hour: "",
      customer: "",
      sellDetail: "",
      paymentMethod: "",
      receipt_id: "Offline",
      receipt_id_store: "",
      total: 0,
      type: "",
    };

    object.id = dailyBalance.id;
    object.created_at_hour = dailyBalance.created_at_hour;
    object.customer =
      dailyBalance.Customer.name == null
        ? ""
        : `${dailyBalance.Customer.name} ${dailyBalance.Customer.lastname}`;
    object.type = dailyBalance.deleted_at == null ? "Venta" : "Nota de Crédito";

    let sellsByCustomer = "";
    let totalByCustomer = 0;

    dailyBalance.Sell_details.forEach((element) => {
      sellsByCustomer +=
        element.Product != null
          ? `${element.quantity} x ${element.Product.name}, `
          : "";
      sellsByCustomer +=
        element.Service != null
          ? `${element.quantity} x ${element.Service.name},`
          : "";
      sellsByCustomer +=
        element.Offer != null
          ? `${element.quantity} x ${element.Offer.name},`
          : "";
      // totalByCustomer += element.Product != null ? element.quantity * element.Product.price : (element.Service != null ? element.quantity * element.Service.price : element.quantity * element.Offer.total_price);
      totalByCustomer += element.total_net;
    });

    object.sellDetail = sellsByCustomer;
    object.paymentMethod = dailyBalance.Sell_payment_type.name;
    object.total = formatHelper.toMoney(totalByCustomer);
    object.receipt_id = dailyBalance.receipt_id
      ? dailyBalance.receipt_id
      : "Offline";
    object.receipt_id_store = `${object.receipt_id} - ${dailyBalance.Store.name}`;
    data.push(object);
  }

  return data;
};

export const selectCategoryBalanceColumns = (state) => {
  const categoryBalanceValue = state.report.categoryBalanceList.categoryBalance;

  var categories = [];
  var data = [];
  var cont = 0;
  if (!categoryBalanceValue || categoryBalanceValue.length == 0)
    return { data, categories };

  Object.keys(categoryBalanceValue).forEach((key) => {
    let object = {
      id: cont,
      Category: {
        name: "",
      },
      totalBought: 0,
    };
    object.Category.name = key;
    categoryBalanceValue[key].forEach((element) => {
      data.push(element);
      object.totalBought += element.totalbought;
    });
    categories.push(object);
    cont++;
  });
  return { data, categories };
};

export const selectReceiptBalance = (state) => {
  const receiptBalanceValue =
    state.report.receiptSellsBalanceList.receiptSellsBalance;
  var data = [];
  if (!receiptBalanceValue || receiptBalanceValue.length == 0) {
    return data;
  }

  const max = receiptBalanceValue.length;

  for (let i = 0; i < max; i++) {
    const receiptBalance = receiptBalanceValue[i];

    let object = {
      id: "",
      name: "",
      customer: "",
      item: "",
      payment: "",
      total: 0,
    };
    object.id = receiptBalance.id;
    object.customer =
      receiptBalance.Customer.name + " " + receiptBalance.Customer.lastname;
    object.item = "";
    object.payment = receiptBalance.receipt_type;
    object.total = receiptBalance.total_net;
    data.push(object);
  }
  return data;
};
export const selectCategoryBalance = (state) => {
  const categoryBalanceValue =
    state.report.categorySellsBalanceList.categorySellsBalance;
  var data = [];
  if (!categoryBalanceValue || categoryBalanceValue.length == 0) {
    return data;
  }

  const max = categoryBalanceValue.length;

  for (let i = 0; i < max; i++) {
    const categoryBalance = categoryBalanceValue[i];
    let object = {
      id: i,
      name: "",
      customer: "",
      item: "",
      payment: "",
      total_net: 0,
    };
    object.name = categoryBalance.Item.Category.name;
    object.customer =
      categoryBalance.Customer.name + " " + categoryBalance.Customer.lastname;
    object.item =
      categoryBalance.Item.quantity + " x " + categoryBalance.Item.name;
    object.payment = categoryBalance.Sell_payment_type.name;
    object.total_net = categoryBalance.Item.total_net;

    data.push(object);
  }
  return data;
};

export const selectOfferDetailsBalanceColumms = (state, details) => {
  const offerDetailsBalanceValue =
    details || state.report.offerDetailsBalanceList.offerDetailsBalance;

  var data = [];

  if (!offerDetailsBalanceValue || offerDetailsBalanceValue.length == 0)
    return data;

  const max = offerDetailsBalanceValue.length;

  for (let i = 0; i < max; i++) {
    const offerDetailsBalance = offerDetailsBalanceValue[i];

    let object = {
      id: 0,
      customer: "",
      sellDetail: "",
      sellDetails: null,
      employee: "",
      paymentMethod: "",
      total: 0,
      quantity: 0,
    };

    object.id = offerDetailsBalance.id;
    object.customer =
      offerDetailsBalance.Customer.name == null
        ? ""
        : `${offerDetailsBalance.Customer.name} ${offerDetailsBalance.Customer.lastname}`;

    let offerBySell = "";
    let employeeBySell = "";
    let totalNet = 0;

    var employeeListArray = [];
    var employeeCountArray = [];
    var employeeIdArray = [];
    var index = 0;

    offerDetailsBalance.Sell_details.forEach((element) => {
      if (element.Offer) {
        offerBySell += `${element.quantity} x ${element.Offer.name}, `;
      } else {
        offerBySell += `${element.quantity} x Sin Servicio, `;
      }
      if (element.Employees) {
        element.Employees.forEach((employee) => {
          if (employee) {
            if (employeeIdArray.includes(employee.id)) {
              index = employeeIdArray.findIndex((id) => id === employee.id);
              employeeCountArray[index] += 1;
            } else {
              employeeIdArray.push(employee.id);
              employeeCountArray.push(1);
              employeeListArray.push(employee.name + " " + employee.lastname);
            }
          }
        });
      }
      totalNet += element.total_net;
    });
    for (let index = 0; index < employeeListArray.length; index++) {
      employeeBySell += `${employeeCountArray[index]} ${employeeListArray[index]}, `;
    }

    if (employeeBySell == "") employeeBySell = "Sin Empleados";
    object.sellDetail = offerBySell;
    object.sellDetails = offerDetailsBalance.Sell_details;
    object.employee = employeeBySell;
    object.paymentMethod = offerDetailsBalance.Sell_payment_type.name;
    object.total = formatHelper.toMoney(totalNet);
    data.push(object);
  }
  return data;
};

export const selectServiceDetailsBalanceColumms = (state) => {
  const serviceDetailsBalanceValue =
    state.report.serviceDetailsBalanceList.serviceDetailsBalance;

  var data = [];

  if (!serviceDetailsBalanceValue || serviceDetailsBalanceValue.length == 0)
    return data;

  const max = serviceDetailsBalanceValue.length;

  for (let i = 0; i < max; i++) {
    const serviceDetailsBalance = serviceDetailsBalanceValue[i];

    let object = {
      id: 0,
      customer: "",
      sellDetail: "",
      sellDetails: null,
      employee: "",
      paymentMethod: "",
      total: 0,
      quantity: 0,
    };

    object.id = serviceDetailsBalance.id;
    object.customer =
      serviceDetailsBalance.Customer.name == null
        ? ""
        : `${serviceDetailsBalance.Customer.name} ${serviceDetailsBalance.Customer.lastname}`;

    let serviceBySell = "";
    let employeeBySell = "";
    let totalNet = 0;

    var employeeListArray = [];
    var employeeCountArray = [];
    var employeeIdArray = [];
    var index = 0;

    serviceDetailsBalance.Sell_details.forEach((element) => {
      if (element.Service) {
        serviceBySell += `${element.quantity} x ${element.Service.name}, `;
      } else if (element.Offer) {
        serviceBySell += `${element.quantity} x (Oferta)(`;
        element.Offer.Offer_services.forEach((offer_service) => {
          serviceBySell += `${offer_service.Service.name}, `;
        });
        serviceBySell += ") ";
      } else {
        serviceBySell += `${element.quantity} x Sin Servicio, `;
      }
      if (element.Employees) {
        element.Employees.forEach((employee) => {
          if (employee) {
            if (employeeIdArray.includes(employee.id)) {
              index = employeeIdArray.findIndex((id) => id === employee.id);
              employeeCountArray[index] += 1;
            } else {
              employeeIdArray.push(employee.id);
              employeeCountArray.push(1);
              employeeListArray.push(employee.name + " " + employee.lastname);
            }
          }
        });
      }
      totalNet += element.total_net;
    });
    for (let index = 0; index < employeeListArray.length; index++) {
      employeeBySell += `${employeeCountArray[index]} ${employeeListArray[index]}, `;
    }

    if (employeeBySell == "") employeeBySell = "Sin Empleados";
    object.sellDetail = serviceBySell;
    object.sellDetails = serviceDetailsBalance.Sell_details;
    object.employee = employeeBySell;
    object.paymentMethod = serviceDetailsBalance.Sell_payment_type.name;
    object.total = formatHelper.toMoney(totalNet);
    data.push(object);
  }
  return data;
};

export const selectTopEmployeesChartData = (state) => {
  const { employeesBalance } = state.report.employeesBalanceList;

  var data = {
    labels: [],
    data: [],
  };

  if (!employeesBalance || employeesBalance.length == 0) return data;

  const max = employeesBalance.length > 10 ? 10 : employeesBalance.length;

  for (let i = 0; i < max; i++) {
    const employee = employeesBalance[i];

    data.labels.push(employee.name);
    data.data.push(formatHelper.toTwoDecimal(employee.totalSold));
  }
  return data;
};

export const selectProductDetailsBalanceColumms = (state) => {
  const productNamesBalanceValue =
    state.report.productNamesBalanceList.productNamesBalance;

  var data = [];

  if (!productNamesBalanceValue || productNamesBalanceValue.length == 0)
    return data;
  const max = productNamesBalanceValue.length;

  for (let i = 0; i < max; i++) {
    const productNamesBalance = productNamesBalanceValue[i];
    let object = {
      id: 0,
      Customer: "",
      employees: "",
      Sell_details: "",
      sellDetails: null,
      Sell_payment_type: "",
      total_net: 0,
    };

    object.id = productNamesBalance.id;
    object.Customer =
      productNamesBalance.Customer == null
        ? "Sin Nombre"
        : `${productNamesBalance.Customer.name} ${productNamesBalance.Customer.lastname}`;

    let productBySell = "";
    let employeeBySell = "";
    let totalNet = 0;

    var employeeListArray = [];
    var employeeCountArray = [];
    var employeeIdArray = [];
    var index = 0;

    productNamesBalance.Sell_details.forEach((element) => {
      productBySell += `${element.quantity} x ${element.Product.name}, `;
      if (element.Employees) {
        element.Employees.forEach((employee) => {
          if (employeeIdArray.includes(employee.id)) {
            index = employeeIdArray.findIndex((id) => id === employee.id);
            employeeCountArray[index] += 1;
          } else {
            employeeIdArray.push(employee.id);
            employeeCountArray.push(1);
            employeeListArray.push(employee.name + " " + employee.lastname);
          }
        });
      }
      totalNet += element.total_net;
    });

    for (let index = 0; index < employeeListArray.length; index++) {
      employeeBySell += `${employeeCountArray[index]} ${employeeListArray[index]}, `;
    }

    if (employeeBySell == "") employeeBySell = "Sin Empleados";
    object.Sell_details = productBySell;
    object.sellDetails = productNamesBalance.Sell_details;
    object.employee = employeeBySell;
    object.Sell_payment_type = productNamesBalance.Sell_payment_type.name;
    object.total_net = formatHelper.toMoney(totalNet);
    data.push(object);
  }
  return data;
};



// WEBPACK FOOTER //
// ./src/store/report/selector.js